import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Spin, Select, InputNumber, Divider, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import { save } from "../../features/save/saveSlice";
import BreadCrumb from "../../layout/BreadCrumb";
import {
  fetchCounties,
  fetchCrops,
  fetchLocation,
  fetchSubCounties,
  fetchSubLocation,
  fetchWaterSources,
} from "../../features/fetch/fetchSlice";

const FarmerAdd = () => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const { counties, subCounties, locations, subLocations,ward,constituency, crops, wtrSources } =
    useSelector((state) => state.fetch);

  const { activeObjFarmers } = useSelector((state) => ({
    activeObjFarmers: state.obj.activeObj["farmers"],
  }));

  const dispatch = useDispatch();
  const navigate = useNavigate();

  function handleCancel() {
    navigate("/farmers-list");
  }

  const [countyName, setCountyName] = useState(
    activeObjFarmers?.countyName ?? ""
  );

  const [subCountyType, setSubCountyType] = useState(
    activeObjFarmers?.usrSubSubCountyId ?? ""
  );
  const handleSubCounty = async (value) => {
    await setSubCountyType(value);
    await dispatch(
      fetchSubCounties({
        subCountyId: value,
      })
    );
    await form.setFieldsValue({
      usrSubSubCountyId: "",
      usrLocationId: "",
      usrSubLocationId: "",
    });
  };

  const [locationType, setLocationType] = useState(
    activeObjFarmers?.usrLocationId ?? ""
  );
  const handleLocation = async (value) => {
    await setLocationType(value);
    await dispatch(
      fetchLocation({
        locSubId: value,
      })
    );
    await form.setFieldsValue({ usrLocationId: "", usrSubLocationId: "" });
  };

  const [subLocationType, setSubLocationType] = useState(
    activeObjFarmers?.usrSubLocationId ?? ""
  );
  const handleSubLocation = async (value) => {
    await setSubLocationType(value);
    await dispatch(
      fetchSubLocation({
        slocLocId: value,
      })
    );
    await form.setFieldsValue({ usrSubLocationId: "" });
  };

  const onFinish = async (data) => {
    data.usrId = activeObjFarmers?.usrId ? activeObjFarmers?.usrId : null;
    // data.countyName = countyName;
    data.usrMajorCrop = Array.isArray(data?.usrMajorCrop)
      ? data?.usrMajorCrop.join(",")
      : data?.usrMajorCrop;
    const res = await dispatch(
      save({
        ...data,
        url: "api/v2/registerFarmer",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await form.resetFields();
      await handleCancel();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      ...activeObjFarmers,
    });
  }, [activeObjFarmers, form]);

  const initialFormValues = {
    ...activeObjFarmers,
    usrMajorCrop: activeObjFarmers?.usrMajorCrop
      ? activeObjFarmers?.usrMajorCrop?.split(",")
      : [],
  };

  useEffect(() => {
    setCountyName(activeObjFarmers?.countyName ?? "");
  }, [activeObjFarmers?.countyName]);

  useEffect(() => {
    dispatch(fetchCounties());
    dispatch(fetchCrops());
    dispatch(fetchWaterSources());
  }, []);

  useEffect(() => {
    if (activeObjFarmers) {
      dispatch(
        fetchSubCounties({
          subCountyId: activeObjFarmers?.usrCountyId,
        })
      );
      dispatch(
        fetchLocation({
          locSubId: activeObjFarmers?.usrSubSubCountyId,
        })
      );
      dispatch(
        fetchSubLocation({
          slocLocId: activeObjFarmers?.usrLocationId,
        })
      );
    }
  }, [activeObjFarmers, form]);

  return (
    <div className="w-full ">
      <BreadCrumb
        breadcrumbs={[
          { title: "Farmers", path: "/farmers-list" },
          { title: "Farmer Form" },
        ]}
      />
      <div className="white_card mt-[2.06rem]">
        <div className="form-add-h mb-[1.25rem]">Register Farmer</div>
        <Divider />
        <div className="w-full mt-[1.75rem]">
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            className=""
            style={{
              maxWidth: "100%",
            }}
            form={form}
            initialValues={initialFormValues}
          >
            
            <div className="custom-title mt-[1.25rem]">Personal Details</div>

            <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
              <Form.Item
                name="usrNationalId"
                label="ID Number"
                rules={[
                  {
                    required: true,
                    message: "National ID is required",
                  },
                  {
                    validator(_, value) {
                      if (value && value.toString().length < 6) {
                        return Promise.reject(
                          "National ID must be at least 6 characters long"
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <InputNumber
                 
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                  className="input flex"
                />
              </Form.Item>

              <Form.Item
                name="fullNames"
                label={"Full Names"}
                rules={[
                  {
                    required: true,
                    message: "Please add full names",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              <Form.Item
                name="email"
                label={"Email"}
                rules={[
                  {
                    required: true,
                    message: "Please add email address",
                  },
                  {
                    type: "email",
                    message: "Please enter a valid email address",
                  },
                ]}
              >
                <Input type="email" className="input" />
              </Form.Item>
              <Form.Item
                name="phoneNumber"
                label={"Active Phone Number"}
                rules={[
                  {
                    required: true,
                    message: "Please add primary phone no",
                  },
                ]}
              >
                <PhoneInput
                  country="ke"
                  onlyCountries={["ke"]}
                  countryCodeEditable={false}
                  className="input rounded-[6px] border !border-[#cacaca] !h-[42px]"
                />
              </Form.Item>
            </div>
            
            <div className="custom-title mt-[2.38rem]">Farm Details</div>
            <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
              <Form.Item
                name="usrCountyId"
                className=""
                label={"County"}
                rules={[
                  {
                    required: true,
                    message: "Please select county",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    counties?.length > 0 &&
                    counties?.map((item) => ({
                      value: item?.countyId,
                      label: item?.countyName,
                    }))
                  }
                  onChange={(value) => {
                    handleSubCounty(value);
                  }}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>

              {subCountyType && (
                <Form.Item
                  name="usrSubSubCountyId"
                  className=""
                  label={"SubCounty"}
                  rules={[
                    {
                      required: true,
                      message: "Please select subcounty",
                    },
                  ]}
                >
                  <Select
                    className=""
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    options={
                      subCounties?.length > 0 &&
                      subCounties?.map((item) => ({
                        value: item?.subId,
                        label: item?.subCountyName,
                      }))
                    }
                    onChange={(value) => {
                      handleLocation(value);
                    }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label?.toLocaleLowerCase() ?? "").includes(
                        input?.toLocaleLowerCase()
                      )
                    }
                  />
                </Form.Item>
              )}

              {locationType && (
                <Form.Item
                  name="usrLocationId"
                  className=""
                  label={"Location"}
                  rules={[
                    {
                      required: true,
                      message: "Please select location",
                    },
                  ]}
                >
                  <Select
                    className=""
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    options={
                      locations?.length > 0 &&
                      locations?.map((item) => ({
                        value: item?.locId,
                        label: item?.locLocation,
                      }))
                    }
                    onChange={(value) => {
                      handleSubLocation(value);
                    }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label?.toLocaleLowerCase() ?? "").includes(
                        input?.toLocaleLowerCase()
                      )
                    }
                  />
                </Form.Item>
              )}

              {subLocationType && (
                <Form.Item
                  name="usrSubLocationId"
                  className=""
                  label={"Sublocation"}
                  rules={[
                    {
                      required: true,
                      message: "Please select sublocation",
                    },
                  ]}
                >
                  <Select
                    className=""
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    options={
                      subLocations?.length > 0 &&
                      subLocations?.map((item) => ({
                        value: item?.slocId,
                        label: item?.slocLocation,
                      }))
                    }
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label?.toLocaleLowerCase() ?? "").includes(
                        input?.toLocaleLowerCase()
                      )
                    }
                  />
                </Form.Item>
              )}

              <Form.Item
                name="usrPhysicalLocation"
                className=""
                label={"Nearest Town"}
                rules={[
                  {
                    required: true,
                    message: "Please give nearest town",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              <Form.Item
                name="usrLandSize"
                extra={"Land Size should not exceed 5 Acres"}
                label={"Land Size (Acre)"}
                rules={[
                  {
                    required: true,
                    message: "Please add land size",
                  },
                ]}
              >
                <InputNumber
                  min={0}
                  max={5}
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                  placeholder="land size"
                  className="input flex"
                />
              </Form.Item>
              <Form.Item
                name="usrWaterSource"
                className=""
                label={"Water Source"}
                rules={[
                  {
                    required: true,
                    message: "Please select water source",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    wtrSources?.length > 0 &&
                    wtrSources?.map((item) => ({
                      value: item?.wsName,
                      label: item?.wsName,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>
              <Form.Item
                label={"Major Crops"}
                name="usrMajorCrop"
                rules={[
                  {
                    required: true,
                    message: "Required field",
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  allowClear
                  showSearch
                  style={{ height: "52px" }}
                  size="large"
                  className=""
                  dropdownRender={(menu) => (
                    <>
                      <Space style={{ padding: "8px 8px 4px" }}>
                        <span className="select-info mt-1">
                          Choose one or more of the following crops
                        </span>
                      </Space>
                      <Divider style={{ margin: "8px 0" }} />
                      {menu}
                    </>
                  )}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.children?.toLowerCase() ?? "").includes(
                      input.toLowerCase()
                    )
                  }
                >
                  {crops?.length > 0 &&
                    crops?.map((item) => (
                      <Select.Option key={item?.cropId} value={item?.cropName}>
                        {item?.cropName}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </div>

            

            <div className="custom-title mt-[2.38rem]"> Alternate contact person</div>

            <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
              <Form.Item
                name="alternateContact"
                label={"Name"}
                rules={[
                  {
                    required: true,
                    message: "Please add name",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>

              <Form.Item
                name="alternatePhoneNumber"
                label={"Phone"}
                rules={[
                  {
                    required: true,
                    message: "Please add phone no",
                  },
                ]}
              >
                <PhoneInput
                  country="ke"
                  onlyCountries={["ke"]}
                  countryCodeEditable={false}
                  className="input rounded-[6px] border !border-[#cacaca] !h-[42px]"
                />
              </Form.Item>
            </div>

            <div className="flex justify-between mt-[48px] ">
              <div className="justify-start"></div>
              <div className="justify-end flex items-center mb-[58px] gap-x-5">
                <div className="w-[150px]">
                  <button
                    type="button"
                    key="back"
                    onClick={handleCancel}
                    className="cstm-btn"
                  >
                    Cancel
                  </button>
                </div>

                <div className="w-[150px]">
                  <button
                    disabled={saving}
                    key="submit"
                    type="submit"
                    className="cstm-btn-2"
                  >
                    {saving ? (
                      <Spin />
                    ) : activeObjFarmers?.usrId ? (
                      "Update"
                    ) : (
                      "Create"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};
export default FarmerAdd;
